import * as Sentry from "@sentry/vue";
import { createI18n } from "vue-i18n";

export const SUPPORTED_LOCALES = ["de", "en", "es"] as const;

const numberFormats = {
  de: {
    decimal: {
      style: "decimal" as const,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  en: {
    decimal: {
      style: "decimal" as const,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  es: {
    decimal: {
      style: "decimal" as const,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
};

export type Locale = (typeof SUPPORTED_LOCALES)[number];
/**
 * i18n setup
 *
 * @returns - The i18n instance
 */
export const i18nInstance = createI18n({
  locale: "de",
  fallbackLocale: ["en", "de"],
  allowComposition: true,
  legacy: false,
  fallbackWarn: false,
  numberFormats,
  missing: (locale, key) => {
    Sentry.captureMessage(
      `Missing translation: key="${key}" in locale="${locale}"`,
      {
        level: "warning",
        extra: {
          locale,
          key,
        },
      },
    );
  },
});
